import address from './address';
import agent from './agent';
import car from './car';
import chat from './chat';
import coBrowsing from './coBrowsing';
import common from './common';
import confirm from './confirm';
import copy from './copy';
import dateTime from './dateTime';
import delegations from './delegations';
import delegationsLight from './delegationsLight';
import discount from './discount';
import errors from './errors';
import exp from './expressions';
import help from './help';
import money from './money';
import number from './number';
import pdf from './pdf';
import person from './person';
import policy from './policy';
import print from './print';
import speedMeter from './speedMeter';
import unit from './unit';
import validation from './validation';
import version from './version';
export default {
    agent,
    common,
    help,
    validation,
    errors,
    exp,
    unit,
    person,
    address,
    car,
    policy,
    dateTime,
    discount,
    money,
    number,
    copy,
    confirm,
    delegations,
    version,
    chat,
    coBrowsing,
    pdf,
    print,
    delegationsLight,
    speedMeter
};
